import Constants from '@/config/constants';

export default class OrderHelper {

  public static getNumberOfBags(orders: any, days: string[], size: string = Constants.regularMealSize) {
    if (orders.logistics && orders.logistics[days[0]] && orders.logistics[days[0]].bags) {
      return orders.logistics[days[0]].bags;
    }
    let total = this.getSizeValue(orders, days, size);
    let bags = 0;
    if (total >= 8) {
      total = total / Constants.largeBagSizeValue;
      bags = Math.ceil(total);
    } else {
      total = total / Constants.smallBagSizeValue;
      bags = Math.ceil(total);
    }
    return bags;
  }

  public static getSizeOfBags(orders: any, days: string[], size: string = Constants.regularMealSize) {
    if (orders.logistics && orders.logistics[days[0]] && orders.logistics[days[0]].bagSize) {
      return orders.logistics[days[0]].bagSize;
    }

    const total = this.getSizeValue(orders, days, size);
    if (total >= 8) {
      return Constants.largeBagSize;
    }
    return Constants.smallBagSize;
  }

  public static getBins(orders: any, days: any) {
    const bins = {};
    {
      for (const day of days) {
        const ordersOnDay = orders.meals[day];
        if (ordersOnDay) {
          try {
            // @ts-ignore
            ordersOnDay.forEach((o) => o.bin && (bins[o.bin] = 1));
          } catch (e) {
            console.error('failed on', {day, ordersOnDay, meals: orders.meals});
            console.error('failure was ', e);
          }
        }
      }
    }
    return Object.keys(bins).sort();
  }

  private static getSizeValue(orders: any, days: string[], size: string) {
    let total = 0.0;
    const mealValue = size === 'small' ? Constants.smallMealSizeValue : Constants.regularMealSizeValue;
    for (const day of days) {
      const order = orders.meals[day];
      if (order) {
        for (const item of order) {
          if (item.meal_type !== 'extras') {
            total += item.quantity * mealValue;
          } else {
            total += item.quantity * Constants.snacksSizeValue;
          }

          if (item.tod === 'breakfast') {
            total += item.quantity * Constants.snacksSizeValue;
          }
        }
      }
    }
    return total;
  }
}
